import Typography from "@mui/material/Typography"
import secondsToString from "@/utils/secondsToString.ts"
import { Segment } from "@/types/types.ts"
import * as React from "react";
import { SliderPlayer } from "@/common/components/Slider/SliderPlayer.tsx";
import { useAudioPlayback } from "@/common/hooks/useAudioPlayback.ts";

type Props = {
  segment: Segment
  progress: number
  currentTime: number
  timeLeft: number
}

const SegmentTableRowPlayerProgressBarSlider = (props: Props) => {
  const {
    segment,
    progress,
    currentTime,
    timeLeft,
  } = props
  const { seek } = useAudioPlayback()

  const handleSliderChange = (_event: Event, value: number | number[]) => {
    updateAudioCurrentTime(value as number)
  }

  const updateAudioCurrentTime = (value: number) => {
    const time = segment.startTime + (getSegmentDuration() * (value / 100))
    seek(time)
  }

  const getSegmentDuration = () => {
    return segment.endTime - segment.startTime
  }

  return (
    <>
      <Typography
        className='children'
        sx={{
          marginLeft: '8px',
          minWidth: '48px',
        }}
      >
        {secondsToString(currentTime)}
      </Typography>
      <SliderPlayer
        step={.1}
        sx={{ mx: 1 }}
        className='children'
        aria-labelledby='continuous-slider'
        value={progress}
        onChange={handleSliderChange}
      />
      <Typography
        className='children'
        sx={{
          marginRight: '5px',
          minWidth: '48px',
        }}
      >
        {secondsToString(timeLeft)}
      </Typography>
    </>
  )
}

export { SegmentTableRowPlayerProgressBarSlider }
